import { get, post, put, deleted } from "../../index";
import ServicesRoutes from "./Services.routes";

const ServicesServices = {
  getAllServices: async (page, limit) => {
    const result = await get(ServicesRoutes.getAllServices + `?page=${page}&limit=${limit}`);
    return result;
  },

  createService: async (obj) => {
    const result = await post(ServicesRoutes.createService, obj);
    return result;
  },

  updateService: async (id, obj) => {
    const result = await put(ServicesRoutes.updateService + `/${id}`, obj);
    return result;
  },

  deleteService: async (id) => {
    const result = await deleted(ServicesRoutes.deleteService + `/${id}`);
    return result;
  }
}

export default ServicesServices;